const GOOGLE_STATE_KEY = 'google_oauth_state';

export function generateGoogleState(): string {
    const state = crypto.randomUUID();
    sessionStorage.setItem(GOOGLE_STATE_KEY, state);
    return state;
}

export function verifyGoogleState(state: string | null): boolean {
    if (!state) return false;
    const stored = sessionStorage.getItem(GOOGLE_STATE_KEY);
    sessionStorage.removeItem(GOOGLE_STATE_KEY);
    return stored === state;
}
